import React, { memo, useState, useCallback } from "react";
import Button from "@material-ui/core/Button";
import type { FC } from "react";
import { Dialog } from "./Dialog";
import { useStyles } from "./ExportTriggerButton.styles";
import { useExportTriggerButton } from "./ExportTriggerButton.state";

export const ExportTriggerButton: FC = memo(() => {
  const classes = useStyles();
  const { disabled, startExport } = useExportTriggerButton();

  const [openDialog, setOpenDialog] = useState(false);

  const handleCloseDialog = useCallback(() => setOpenDialog(false), [setOpenDialog]);
  
  const handleClick = useCallback(() => {
    startExport();
    setOpenDialog(true);
  }, [setOpenDialog, startExport]);

  return (
    <>
      <Dialog open={openDialog} onClose={handleCloseDialog} />

      <Button color="primary" variant="contained" title={"Export"} onClick={handleClick} classes={classes} disabled={disabled}>
        Export
      </Button>
    </>
  );
});
